import { AxiosError } from 'axios';
import { useCallback } from 'react';
import { useNewRewardsApi } from 'Shared/services/Api';

export declare type GetAgentRewardsResponse = {
  lifetimePoints: number;
  currentPoints: number;
  acceptedTermsAndConditions: boolean;
};

export type AgentRewardsPointsProviderType = {
  agentRewardsPointsResponse: GetAgentRewardsResponse | null;
  agentRewardsPointsLoading: boolean;
  agentRewardsPointsError: AxiosError<any> | undefined;
  refreshAgentRewardsPoints(): Promise<GetAgentRewardsResponse>;
};

export const useRewardsPoints = (): AgentRewardsPointsProviderType => {
  const [
    {
      data: agentRewardsResponse,
      loading: agentRewardsLoading,
      error: agentRewardsError,
      refetch: fetchAgentRewards,
    },
  ] = useNewRewardsApi<GetAgentRewardsResponse>(
    {
      url: `/v1/points`,
    },
    false,
    false
  );

  const refreshAgentRewards = useCallback(async () => {
    return (await fetchAgentRewards()).data;
  }, [fetchAgentRewards]);

  return {
    agentRewardsPointsResponse: agentRewardsResponse,
    agentRewardsPointsLoading: agentRewardsLoading,
    agentRewardsPointsError: agentRewardsError,
    refreshAgentRewardsPoints: refreshAgentRewards,
  };
};
